import styled from "@emotion/styled";
import { IconLetter } from "@kompare/kompare-ui-library";
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { i18n, mediaQuery, ProductTypeCodeEnum, setProgressBarPercentage, useAppDispatch } from 'src/common';
import { processQueryResult } from 'src/common/api/apollo';
import { useGetGeneralTransferPaymentDetailsQuery } from 'src/common/api/apollo/supplementary';
import { BarcodeCard, Button, Flex, Loader, StatusMessage } from 'src/components';
import config from 'src/config';
import { colors, footer, header } from 'src/theme';


const ButtonContainerStyle = styled.div({
  marginTop: 32,
  textAlign: 'center',
})

const FlexStyle = styled(Flex)({
  minHeight: `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)`,

  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height + header.mobileHeight + 80}px)`,
  },

  [mediaQuery('laptopL')]: {
    minHeight: `calc(100vh - ${footer.height + header.height + 80}px)`,
  },
});

const CheckoutExecutePaymentPage = () => {
  const dispatch = useAppDispatch();

  const params = useParams<{ offerId: string }>();
  const offerId = params.offerId as string;

  useEffect(() => {
    dispatch(setProgressBarPercentage(0));
  }, []);

  const { loading, data } = useGetGeneralTransferPaymentDetailsQuery({
    variables: { id: offerId, input: { installments: 1, type: ProductTypeCodeEnum.DOPUNSKO } },
    fetchPolicy: 'cache-first',
    onCompleted: (result: any) => {
      processQueryResult(result);
    }
  });

  if (loading) return <Loader page />;
  const checkoutHealthOfferGeneralTransferDetails = data?.getGeneralTransferPaymentDetails;

  const navigateToHome = () => {
    window.location.href = config.REACT_APP_KOMPARE_HOME!;
  };

  const Buttons = () => (
    <ButtonContainerStyle>
      <Button btnType='textBlack' onClick={navigateToHome}>
        {i18n.t('pages.checkoutCongratulationsPage.returnToHomeButton')}
      </Button>
    </ButtonContainerStyle>
  );

  return (
    <FlexStyle justify='center' align='center'>
      <StatusMessage barcode={<BarcodeCard data={checkoutHealthOfferGeneralTransferDetails} paymentType={'oneTime'} />} buttons={<Buttons />} icon={<IconLetter color={colors.icon4} />} title={i18n.t('pages.checkoutExecutePaymentPage.title')} subtitle={i18n.t('pages.checkoutExecutePaymentPage.subtitle')} />
    </FlexStyle>
  );
}

export default CheckoutExecutePaymentPage;
